import {
  AuditReportsGipEvidenceExportOptionsDto,
  AuditReportsPublicJobDto,
  AuditReportsPublicJobDtoStatusEnum,
  useAuditReportsEvidenceExportGipAltReport,
  useAuditReportsGetGipAltReportEvidenceExportUrl,
  useAuditReportsGetGipAltReportExportStatus,
} from '@mi-front/api-v2';
import { reportError } from '@app/core/integrations/bugsnag';
import { useCreatedReport } from '@app/modules/audit/modules/global-audit/hooks/useCreatedReport';
import { useQueryClient } from '@tanstack/react-query';
import { ReportExportApi } from './report-export-api';

export function useGipAltExportApi(): ReportExportApi {
  const queryClient = useQueryClient();

  const exportMutation = useAuditReportsEvidenceExportGipAltReport({
    mutation: {
      onSuccess: (_data, variables) => {
        if (variables?.id) {
          queryClient.invalidateQueries({
            queryKey: useCreatedReport.queryKey(variables.id),
          });
        }
      },
      onError: (error: any) => {
        reportError(error);
      },
    },
  });

  return {
    exportReport: async (id: string, options: unknown) => {
      await exportMutation.mutateAsync({
        id,
        data: options as AuditReportsGipEvidenceExportOptionsDto,
      });
    },
    useExportStatus: (id: string, enabled: boolean) =>
      useAuditReportsGetGipAltReportExportStatus(id || '', {
        query: {
          enabled,
          refetchInterval: (query) => {
            const status = (query.state.data as AuditReportsPublicJobDto | undefined)?.status;
            return status === AuditReportsPublicJobDtoStatusEnum.IN_PROGRESS ? 1000 : false;
          },
        },
      }),
    useExportUrl: (id: string, enabled: boolean) =>
      useAuditReportsGetGipAltReportEvidenceExportUrl(id, {
        query: {
          enabled,
        },
      }),
  };
}
